import { Mask } from "./Mask";
import { masks } from "./masks";

export class CpfMask implements Mask {
  searchValue = masks.cpf.searchValue;
  replaceValue = masks.cpf.replaceValue;
  maxLength = 11;

  execute(value: string): string {
    const numericValueCPF = value.replace(/\D/g, "");
    // Remove caracteres excedentes (CPF só tem 11 dígitos)
    const limitedValueCPF = numericValueCPF.substring(0, this.maxLength);
    // Aplica a máscara enquanto digita
    if (limitedValueCPF.length === this.maxLength) {
      return this.format(limitedValueCPF);
    }
    return limitedValueCPF;
  }

  format(value: string): string {
    return value
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4")
      .trim();
  }
}
